import { useEffect } from 'react';

import IterableEmbeddedService from './IterableEmbeddedService';

interface UseEmbeddedSyncOptions {
  /** Whether the Iterable SDK has been initialized (and the user is authed). */
  isInitialized: boolean;
  /** Numeric Iterable placement IDs to fetch content for. */
  placementIds: number[];
}

/**
 * Fetches embedded messages from Iterable once per app session.
 *
 * Cadence (per EN-11780): on page load only, after the SDK reports
 * `isInitialized`. Route-change refresh and polling are intentionally deferred
 * — when Marketing wants near-real-time eligibility updates we can add a
 * polling layer or a route-change subscription here, but for the initial roll
 * out a single fetch keeps the API surface predictable and Iterable load light.
 */
export function useEmbeddedSync({ isInitialized, placementIds }: UseEmbeddedSyncOptions): void {
  const placementsKey = placementIds.join(',');
  useEffect(() => {
    if (!isInitialized || placementsKey === '') {
      return;
    }
    const ids = placementsKey.split(',').map(Number);
    IterableEmbeddedService.syncMessages(ids).catch((err: unknown) => {
      // eslint-disable-next-line no-console -- embedded fetch errors are non-fatal
      console.error('Failed to sync Iterable embedded messages:', err);
    });
  }, [isInitialized, placementsKey]);
}
